<template>
    <transition name="fade" v-if="isAndroid && isInstalled" >
        <b-container v-if="isAppLoading" :class="{'splash-screen': true, 'blue': isIntuitApp, 'green': isJAApp}">
            <b-row class="text-center top-splash-screen blue" v-if="isIntuitApp">
                <b-col cols="12">
                    <img src="../Images/intuit_logo_white.svg" class="img-logo-intuit" alt="Design for Delight by INTUIT">
                </b-col>
            </b-row> 
            <b-row class="text-center bottom-splash-screen" v-if="isIntuitApp">
                <b-col cols="12">
                    <img src="../Images/in-partnership-with-ja.svg" class="img-logo img-logo-ja" alt="Junior Achievement">
                </b-col>
            </b-row> 
            <b-row class="text-center top-splash-screen green" v-if="isJAApp">
                <b-col cols="12">
                    <img src="../Images/ja_logo_white.svg" class="img-logo img-logo-ja" alt="Junior Achievement">
                </b-col>
            </b-row> 
            <b-row class="text-center bottom-splash-screen"  v-if="isJAApp">
                <b-col cols="12">
                    <img src="../Images/sponsored_by_intuit.svg" class="img-logo img-logo-intuit" alt="Design for Delight by INTUIT">
                </b-col>
            </b-row> 
        </b-container>
    </transition>
</template>

<script>
    import { EventBus, SplashScreen } from '../Utils'
    import { isAndroid } from 'mobile-device-detect';

    export default {
        name: "SplashScreen",
        data() {
            return {
                isAppLoading: true,
                isAndroid: isAndroid,
                isInstalled: false,
            }
        },
        created() {
            EventBus.$on(SplashScreen.EVENT_SHOW, () => {
                this.isAppLoading = true
            })
            EventBus.$on(SplashScreen.EVENT_HIDE, () => {
                this.isAppLoading = false
            })
            if (window.matchMedia('(display-mode: standalone)').matches) {
                this.isInstalled = true
            }
        }
    }
</script>

<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    @import "~@/core/Styles/transitions.styl"

    .splash-screen
        margin-top -5px !important
        width 100% !important
        max-width 100% !important
        min-height calc(100vh + 5px)
        position absolute
        width 100% !important
        height 100% !important
        z-index 99999 !important

        &.blue
            background-color color-blue-light
        &.green
            background-color color-green
    
        .top-splash-screen
            position absolute
            top 50%
            margin-top -73px
            width 100%

            .img-logo-intuit
                min-width 130px
                width 240px
                height auto
                
            .img-logo-ja
                min-width 130px
                width 191px
                height auto
                
            @media (max-width: 500px)
                .img-logo-intuit
                    width 40%
                    margin-top: -17%;
                .img-logo-ja
                    width 40%
                    margin-top: -17%;
                   
        @media (max-width: 500px)
            .top-splash-screen
                margin-top 0px  
    
        .bottom-splash-screen
            width 100%
            position absolute
            bottom 0
            background-color color-blank
            min-height 73px
            
            .img-logo-intuit
                width 204px
                min-width 130px
                margin-top 15px
                
            .img-logo-ja
                width 242px
                min-width 130px
                margin-top 15px
            
            @media (max-width: 500px)
                .img-logo-intuit
                    width 40%
                .img-logo-ja
                    width 50%
</style>